import { createSlice } from "@reduxjs/toolkit";

const initialTransporterState = {
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: [],
    transporterForEdit: undefined,
    lastError: null,
    currentTab: "accounts",
    message: null,
    error: null,
};
export const callTypes = {
    list: "list",
    action: "action"
};

export const transporterSlice = createSlice({
    name: "transporters",
    initialState: initialTransporterState,
    reducers: {
        catchError: (state, action) => {
            state.error = action.payload.error.clientMessage;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        startCall: (state, action) => {
            state.error = null;
            state.message = null;

            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            }
        },
        endCall: (state, action) => {
            state.error = null;
            state.message = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        // getTransporterById
        transporterFetched: (state, action) => {
            state.actionsLoading = false;
            state.transporterForEdit = action.payload.transporterForEdit;
            state.floorPlans = action.payload.transporterForEdit.floorPlans;
            state.error = null;

        },
        // getTransporterChart
        transporterChartFetched: (state, action) => {

            state.actionsLoading = false;
            state.transporterChart = action.payload.transporterChart;
            state.error = null;

        },
        // getTransporterChart
        transporterHourlyChartFetched: (state, action) => {
            state.actionsLoading = false;
            state.transporterChartHour = action.payload.transporterChartHour;
            state.error = null;

        },
        // getTransporterChart
        transporterHourlyZoneChartFetched: (state, action) => {
            state.actionsLoading = false;
            state.transporterChartHourZone = action.payload.transporterChartHourZone;
            state.error = null;

        },
        // get list data
        transportersFetched: (state, action) => {
            const { totalCount, entities } = action.payload;
            state.listLoading = false;
            state.error = null;
            state.entities = entities;
            state.totalCount = totalCount;
            state.transporterForEdit = undefined;
            state.floorPlans = undefined;
            state.transporterChart = undefined;
            state.transporterChartHour = undefined;
            state.transporterChartHourZone = undefined;
        },
        // createTransporter
        transporterCreated: (state, action) => {
            state.actionsLoading = false;
            state.error = null;
            state.message = action.payload.msgResponse;
        },
        // updateTransporter
        transporterUpdated: (state, action) => {
            state.error = null;
            state.actionsLoading = false;
            state.message = action.payload.msgResponse;
        },
        // transporterDeleted
        transporterDeleted: (state, action) => {
            state.error = null;
            state.message = action.payload.msgResponse;
            state.actionsLoading = false;
        },
        setMessage: (state, action) => {
            state.error = null;
            state.message = action.payload.msgResponse;
        },
        setTab: (state, action) => {
            state.error = null;
            state.actionsLoading = false;
            state.currentTab = action.payload.tab;
        },
        userCreated: (state, action) => {
            state.error = null;
            state.actionsLoading = false;
            state.message = action.payload.msgResponse;
        }

    }
});
